import {pullRequestFeedbackAutomatedReviewCommentPath} from '@github-ui/paths'
import {useRoutePayload} from '@github-ui/react-core/use-route-payload'
import type {FilesRoutePayload} from '@github-ui/pull-requests/page-data/payloads/files'

export function useAutomatedReviewFeedback(automatedCommentId: string, path?: string) {
  const payload = useRoutePayload<FilesRoutePayload>()
  const basePath = payload?.pullRequest?.pathName || path
  if (!basePath) {
    throw new Error('basePath could not be determined: both payload.pullRequest and path are undefined')
  }

  const feedbackPath = pullRequestFeedbackAutomatedReviewCommentPath({
    basePath,
    automatedReviewCommentId: automatedCommentId,
  })

  return {
    feedbackPath,
  }
}
